import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: 'ml.quoteandbind.header.MetLife Header',
        defaultMessage: 'MetLife Header',
    },
    login: {
        id: 'ml.quoteandbind.header.LOG IN',
        defaultMessage: 'LOG IN',
    },
    faq: {
        id: 'ml.quoteandbind.header.FAQ',
        defaultMessage: 'FAQ',
    }
});
